import React, {useState, useRef, useEffect} from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import {
  changeHandler,
  validateHandler,
  getCities,
  getStreets,
  getZipCode,
  getFiberStatus,
  initValidation,
  setIsNotFoundError,
  clearAddress,
  resetBlock,
  setIsFromBack,
  setIsShowPopUp,
  clearFiberData,
  clearFiberStatusSuccess,
  reportAnalytics,
  fiberStatusSuccessClear,
  zipExistClear,
  clearAddressDetails,
} from './addressFrmSlice';
import Autocomplete from '../AutoCompleteInput/AutoCompleteInput.js';
import { Col, Row } from 'reactstrap';
import TextInput from '../TextInput/TextInput';
import { connect } from 'react-redux';
import BtnPinkSmall from '../Buttons/BtnPinkSmall';
import PopUp from '../Popup/PopUp';
import ReactSelect from '../ReactSelect/ReactSelect';
import { showAppLoader, hideAppLoader, showOverlay } from '../Loader/LoaderSlice';

const AddressFrm = (props) => {
  let cityDefaultVal = props.cityDefault;
  let streetDefaultVal = props.streetDefault;
  const [isValidAddress, setIsValidAddress] = useState(false);
  const [isEntrySelected, setIsEntrySelected] = useState(false);
  const [homeDefaultValue, setHomeDefaultValue] = useState('');
  const [cityDefault, setCityDefault] = useState('');
  const [streetDefault, setStreetDefault] = useState('');
  const [parentValue, setParentValue] = useState('');
  const streetRef = useRef();
  const homeRef = useRef();
  const [isShowEntryError, setIsShowEntryError] = useState(false);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit && props.onSubmit == true) {
          props.initValidation();
          props.validateHandler(props.form);
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.valid !== '') {
          handleValidateChange();
        }
      }
    },
    [props.form.valid]
  );

  const getZipCode = () => {
    const params = {
      street: props.form.street,
      city: props.form.city,
      houseNum: props.form.home,
      entry: props.form.enter
    };

    let isNumber = /^\d+$/.test(props.form.home);

    if (isNumber) {
      props.getZipCode(params);
    }
  };

  const getFiberStatus = () => {
    props.clearFiberData();
    const params = {
      street: props.form.street,
      city: props.form.city,
      houseNum: props.form.home,
      entry: props.form.enter,
      apartment: props.form.apartment ? props.form.apartment : '1',
    };

    let isNumber = /^\d+$/.test(props.form.home);

    if (isNumber) {
      props.getFiberStatus(params);
    }
  };

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.errorObj != '') {
          props.onError(props.form.errorObj.errorId);
        }
      }
    },
    [props.form.errorObj]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.fiberData?.errorObj?.errorId && props.fiberData.errorObj.errorId != '') {
          props.onError(props.fiberData.errorObj.errorId);
        }
      }
    },
    [props.fiberData.errorObj]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
    }

    props.getCities();
    if (props.noDefaultValuesOnRender !== true) {
      setDefaultValues();
    }

    return () => {
      if (runSideEffects()) {
        //props.hideAppLoader();
      }
    };
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.city != '' && props.form.city != ' ' && props.form.city != undefined) {
          props.clearAddressDetails();
          setParentValue(props.form.city);
          props.getStreets(props.form.city);
        }
      }
    },
    [props.form.city]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.cityName != '') setFocus('street');
      }
    },
    [props.form.cityName]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.streetName != '') setFocus('home');

        if (props.form.isCityWithoutStreets == true) {
          if (props.form.home != '') {
            if (props.onHomeChange) props.onHomeChange(true);
          }
          setHomeDefaultValue('0');
        } else setHomeDefaultValue('');
      }
    },
    [props.form.streetName]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.isGetFiberStatusSuccess == true && props.fiberData.entryList.length > 1) {
          //props.hideAppLoader({ isLoading: false });
          setIsValidAddress(false);
          props.initValidation();
          openPopUp();
        }
        //if (props.form.valid != '') getZipCode();
      }
    },
    [props.form.isGetFiberStatusSuccess]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.valid) {
        if (props.isCheckFiberAddress) {
          if (
            isValidAddress &&
            props.form.zipExist !== '' &&
            props.form.zipCode !== '' &&
            props.form.isGetFiberStatusSuccess == true &&
            props.form.isSelectEntry == true
          ) {
            props.onValid(isValidAddress);
            props.initValidation();
          }
        } else {
          if (isValidAddress && props.form.zipExist !== '' && props.form.zipCode !== '') {
            props.onValid(isValidAddress);
            props.initValidation();
          }
        }
      }
    }
  });


  const keyUpHandler = () => {
    if (props.onHomeChange) {
      if (props.form.home != '') props.onHomeChange(true);
    }
  };

  const handleValidateChange = () => {
    let isValid = props.form.valid;
    if (isValid) {
      setIsValidAddress(true);
    } else {
      setIsValidAddress(false);
      //props.hideAppLoader();
    }

    if (props.onValid) {
      if (isEntrySelected && isValid == true) {
        props.fiberStatusSuccessClear();
        props.onValid(true);
      }

      if (props.isCheckFiberAddress) {
        if (isValid && props.form.isGetFiberStatusSuccess == false && props.form.zipExist === '') {
          getFiberStatus();
        }
      } else {
        if (isValid && props.form.zipExist === '') {
          getZipCode();
        }
      }

      if (!isValid && props.form.zipExist === '') {
        props.initValidation();
        props.onValid(false);
      }
    } else {
      props.initValidation();
      props.onValid(false);
    }
  };

  const closePopUp = () => {
    props.setIsShowPopUp(false);
    props.onValid(false);
    props.initValidation();
    props.zipExistClear();
  };

  const openPopUp = () => {
    props.fiberStatusSuccessClear();
    props.initValidation();
    setIsShowEntryError(false);
    props.setIsShowPopUp(true);
    if (!props.avoidGaReport) {
      props.reportAnalytics({
        eventCategory: 'fiber_newsale_process',
        eventAction: 'visibility_2',
        eventLabel: 'element_1',
      });
    }
  };

  const handleContinue = () => {
    if (!props.avoidGaReport) {
      props.reportAnalytics({
        eventCategory: 'fiber_newsale_process',
        eventAction: 'click_2',
        eventLabel: 'button_2',
      });
    }

    if (props.form.enter != '') {
      setIsShowEntryError(false);
      setIsEntrySelected(true);
    } else {
      setIsEntrySelected(false);
      setIsShowEntryError(true);
      props.onValid(false);
      return;
    }

    props.validateHandler(props.form);
  };


  function resultsNotFound(obj) {
    props.setIsNotFoundError({ isNotFoundError: obj.value });
  }

  const scrollInto = (inputName) => {
    const input = document.querySelector('input[name=' + inputName + ']');

    if (input !== null && window.innerHeight <= 350) {
      input.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const setFocus = (name) => {
    switch (name) {
      case 'street':
        if (streetRef.current) streetRef.current.autoCompleteRef.current.focus();
        break;
      case 'home':
        if (homeRef.current) homeRef.current.focus();
        break;
    }
  };

  const setDefaultValues = () => {
    if (props.cities.length > 0 && props.form.home != '') {
      setCityDefault(props.form.cityName);
      props.setIsFromBack();
      //props.hideAppLoader();
    }

    if (props.cities.length > 0 && props.form.home != '') {
      setStreetDefault(props.form.streetName);
    }

    if (props.form.isCityWithoutStreets == true) setHomeDefaultValue('0');

    props.initValidation();
    //props.clearFiberData();
    props.clearFiberStatusSuccess();

  };

  return (
    <div>
      <div className='container-fluid main no-padding'>
        <div className='component-container' style={props.saleType == 'cellular' ? { marginTop: '20px' } : { marginTop: '10px' }}>
          <div className='address-form'>
            <p>{props.title ? props.title : 'הכתובת שלכם'}</p>
            <p>שדות עם כוכבית הם חובה</p>
            <div onClick={() => scrollInto('city')} name='cityContainer'>
              <Autocomplete
                autofocus={props?.dontAutoFocus ? false : true}
                defaultValue={cityDefaultVal}
                injectedValue={cityDefault}
                error={props.form.errors.city}
                value={props.form.city}
                resultsNotFound={resultsNotFound}
                id='city'
                name='city'
                //onSelectedChange={props.changeHandler}
                onSelectedChange={(e) => props.changeHandler({ target: e.target, form: props.form, cities: props.cities })}
                form={props.form}
                //suggestions={props.form.cities}
                suggestions={props.cities}
                dataKey='cityCode'
                dataValue='cityName'
                placeholder='שם יישוב'
                required='required'
              />
            </div>

            {!props.form.isCityWithoutStreets ? (
              <Autocomplete
                ref={streetRef}
                defaultValue={streetDefaultVal}
                injectedValue={streetDefault}
                updateValue={parentValue}
                error={props.form.errors.street}
                value={props.form.street}
                id='street'
                name='street'
                disabled={props.form.isSelectedCity ? '' : 'disabled'}
                //onSelectedChange={props.changeHandler}
                onSelectedChange={(e) => props.changeHandler({ target: e.target, form: props.form, streets: props.streets })}
                form={props.form}
                //suggestions={props.form.streets}
                suggestions={props.streets}
                dataKey='streetCode'
                dataValue='streetName'
                placeholder='רחוב'
                required='required'
              />
            ) : (
              <TextInput
                error={props.form.errors.apartment}
                placeholder='רחוב'
                id='dummyStreet'
                name='dummyStreet'
                type='text'
                disabled
                maxLength='10'
                autoComplete='off'
                value={props.form.streetName}
                required='required'
              />
            )}

            <PopUp showPopUp={props.form.isShowPopUp} onClose={closePopUp}>
              <div>
                <p className='top-title'>יש בבניין כמה כניסות.</p>
                <p className='main-title'>על איזו אחת אנחנו מדברים?</p>
                <div className='entry'>
                  <ReactSelect
                    error={isShowEntryError ? 'לא נבחרה כניסה' : ''}
                    getOptionLabel={(option) => option.value}
                    getOptionValue={(option) => option.key}
                    placeholder='בחרו כניסה'
                    isLoading={props.form.isLoading}
                    value={props.fiberData.entryList.filter((option) => option.key === props.form.enter)}
                    name='enter'
                    options={props.fiberData.entryList}
                    onChange={(e) =>
                      props.changeHandler({ target: { name: 'enter', value: e.key }, form: props.form, fiberData: props.fiberData })
                    }
                  />
                </div>

                <div className='btn-pink-holder'>
                  <BtnPinkSmall
                    text='המשך'
                    onclick={() => {
                      handleContinue();
                    }}
                  />
                </div>
              </div>
            </PopUp>

            <Row>
              <Col ms={6}>
                <TextInput
                  ref={homeRef}
                  error={props.form.errors.home}
                  placeholder='בית'
                  id='home'
                  name='home'
                  maxLength='10'
                  disabled={props.form.isSelectedStreet ? '' : 'disabled'}
                  type='number'
                  pattern='[0-9]*'
                  autoComplete='off'
                  value={!props.form.isCityWithoutStreets && props.form.home != undefined ? props.form.home : homeDefaultValue}
                  onKeyUp={keyUpHandler}
                  onChange={(e) => props.changeHandler({ target: e.target, form: props.form })}
                  required='required'
                />
              </Col>
              <Col ms={3}>
                <TextInput
                  error={props.form.errors.apartment}
                  placeholder='דירה'
                  id='apartment'
                  disabled={props.form.isSelectedStreet ? '' : 'disabled'}
                  name='apartment'
                  type='number'
                  pattern='[0-9]*'
                  maxLength='10'
                  autoComplete='off'
                  value={props.form.apartment != undefined ? props.form.apartment : ''}
                  onChange={(e) => props.changeHandler({ target: e.target, form: props.form })}
                  required={props.isApartmentRequired ? 'required' : undefined}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.addressForm.form,
    fiberData: state.addressForm.fiberData,
    cities: state.addressForm.cities,
    streets: state.addressForm.streets,
    alternateForm: state.addressForm.alternateForm
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  getCities,
  getStreets,
  getZipCode,
  getFiberStatus,
  showAppLoader,
  hideAppLoader,
  showOverlay,
  initValidation,
  setIsNotFoundError,
  clearAddress,
  resetBlock,
  setIsFromBack,
  setIsShowPopUp,
  clearFiberData,
  clearFiberStatusSuccess,
  reportAnalytics,
  fiberStatusSuccessClear,
  zipExistClear,
  clearAddressDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressFrm);
